import React, { useState, useEffect } from "react";

export default function ContactUs() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Responsive styles
  const sectionStyle = {
    position: "relative",
    top: windowSize.width < 768 ? "0px" : "200px",
    padding: windowSize.width < 768 ? "30px 15px" : "50px 20px",
    maxWidth: "800px",
    marginBottom: "30vh",
    marginTop: "10vh",
  };

  const headingStyle = {
    textAlign: "center",
    fontSize: windowSize.width < 768 ? "1.8em" : "2.2em",
    marginBottom: "30px",
    color: "#2c3e50",
  };

  const contactCardStyle = {
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
    padding: "30px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
  };

  const contactItemStyle = {
    marginBottom: "20px",
    fontSize: windowSize.width < 768 ? "1em" : "1.1em",
    lineHeight: "1.6",
  };

  const labelStyle = {
    fontWeight: "600",
    color: "#3498db",
    marginRight: "10px",
  };

  return (
    <div style={{display: "flex", justifyContent: "center"}}>
      <section style={sectionStyle}>
        <h1 style={headingStyle}>Contact Us</h1>

        <div style={contactCardStyle}>
          <div style={contactItemStyle}>
            <span style={labelStyle}>Controller of Examinations</span>
          </div>

          <div style={contactItemStyle}>
            <span style={labelStyle}>Office:</span>
            Office of Controller of Examinations, JSS University, Noida
          </div>

          <div style={contactItemStyle}>
            <span style={labelStyle}>Address:</span>
            C20/1, Sector-62, Noida, GB Nagar-201301 Uttar Pradesh
          </div>

          <div style={contactItemStyle}>
            <span style={labelStyle}>Phone:</span>
            0120-2401484 (Ext: 214, 262)
          </div>

          <div style={contactItemStyle}>
            <span style={labelStyle}>Email:</span>
            <a
              href="mailto:coe@jssuninoida.edu.in"
              style={{ color: "#2980b9" }}
            >
              coe@jssuninoida.edu.in
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
